import React from 'react';

export default function ContactUs(props) {
  var data = props.data || {};
  var main = props.main || {};
  var linkedIn = (main.social || []).find(function(item) {
    return item.name === 'linkedin';
  });
  var github = (main.social || []).find(function(item) {
    return item.name === 'github';
  });

  return (
    <section id="contact" className="section contact-section">
      <div className="contact-panel">
        <div>
          <p className="eyebrow">Contact</p>
          <h2>{data.heading}</h2>
          <p>{data.message}</p>
          <p className="availability">{data.availability}</p>
        </div>

        <div className="contact-actions">
          <a className="button primary" href={'mailto:' + main.email}>
            {main.email}
          </a>
          {linkedIn && (
            <a className="button secondary" href={linkedIn.url} target="_blank" rel="noreferrer">
              LinkedIn
            </a>
          )}
          {github && (
            <a className="button secondary" href={github.url} target="_blank" rel="noreferrer">
              GitHub
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
